<div class="flex-column flex bg-grey-white_smoke dark:bg-black" ridangoAriaVisibilityObserver>
    <ng-template #stickyHeader>
        <div
            class="bg-white p-3 shadow-md"
            [ngClass]="{
                'pb-0': env.EXPLORE?.SHOW_FAVORITE_STOPS,
                'pt-0': isMobileView
            }">
            <ng-container *ngIf="deviceStatus">
                <ion-searchbar
                    class="rounded-md text-black dark:bg-contrast-yellow"
                    id="explore-search"
                    [placeholder]="'EXPLORE_SEARCH_PLACEHOLDER' | translate"
                    (pointerdown)="markSearchbarPointerDown()"
                    (click)="openSearchModal()"
                    (keydown.enter)="openSearchModal($event)"
                    ridangoAutofocus
                    show-clear-button="never"
                    mode="ios"></ion-searchbar>

                <div class="mt-3" *ngIf="hasLocationError" [ngClass]="{ 'pb-3': env.EXPLORE?.SHOW_FAVORITE_STOPS }">
                    <ridango-ui-alert type="info">
                        <div>
                            {{ 'EXPLORE_TURN_ON_LOCATION' | translate }}
                        </div>
                    </ridango-ui-alert>
                </div>
            </ng-container>

            <div class="flex items-center gap-2">
                <div class="flex-justify-between flex flex-1 overflow-x-auto">
                    <div class="w-[50%] min-w-[33%] max-w-[50%]" *ngIf="showNearbyTab()">
                        <ridango-ui-tab-button
                            class="uppercase"
                            [class.normal-case]="env.REMOVE_UPPERCASE"
                            [ariaLabel]="'NEARBY' | translate"
                            [isSelected]="selectedTab === TABS.nearby"
                            [tabsCount]="getTabsCount()"
                            [tabIndex]="1"
                            (click)="handleTabSelect(TABS.nearby)"
                            >{{ 'NEARBY' | translate }}
                        </ridango-ui-tab-button>
                    </div>

                    <div class="w-[50%] min-w-[33%] max-w-[50%]" *ngIf="showRoutesTab()">
                        <ridango-ui-tab-button
                            class="uppercase"
                            [class.normal-case]="env.REMOVE_UPPERCASE"
                            [isSelected]="selectedTab === TABS.routes"
                            [ariaLabel]="'ROUTES' | translate"
                            [tabsCount]="getTabsCount()"
                            [tabIndex]="getTabIndex(2)"
                            (click)="handleTabSelect(TABS.routes)"
                            >{{ 'ROUTES' | translate }}
                        </ridango-ui-tab-button>
                    </div>

                    <div class="w-[50%] min-w-[33%] max-w-[50%]">
                        <ridango-ui-tab-button
                            class="uppercase"
                            [class.normal-case]="env.REMOVE_UPPERCASE"
                            [ariaLabel]="'FAVORITES' | translate"
                            [isSelected]="selectedTab === TABS.favorites"
                            [tabsCount]="getTabsCount()"
                            [tabIndex]="getTabIndex(3)"
                            (click)="handleTabSelect(TABS.favorites)"
                            >{{ 'FAVORITES' | translate }}
                        </ridango-ui-tab-button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <div
        class="-mb-4 ml-4 box-border flex h-12 items-center justify-between dark:border-contrast-yellow"
        *ngIf="
            (env.EXPLORE?.SHOW_REFRESH_BUTTON && selectedTab === TABS.nearby && getNearbyStopsPatch().length) ||
            (selectedTab === TABS.favorites && (favoriteLocations?.length || favoriteStopsSaved?.length))
        ">
        <p class="var-app-light-dark:text-black ml-auto text-xs text-gray-500 dark:text-contrast-yellow">
            {{ 'RESULTS_FROM' | translate }}
            {{ minutesSinceRefresh$ | async }}
            {{ 'MIN_AGO' | translate }}
        </p>
        <div
            (click)="$event.stopPropagation()"
            (mousedown)="$event.stopPropagation()"
            (touchstart)="$event.stopPropagation()">
            <ion-button
                [attr.aria-label]="'REFRESH' | translate"
                (click)="handleRefreshClick($event)"
                size="small"
                fill="clear">
                <ion-icon
                    class="var-app-light-dark:text-black h-8 w-8 text-secondary dark:filter-yellow"
                    [attr.aria-label]="'REFRESH' | translate"
                    title="{{ 'REFRESH' | translate }}"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-refresh.svg"></ion-icon>
            </ion-button>
        </div>
    </div>

    <!-- Favorites Tab Content -->
    <ng-container *ngIf="selectedTab === TABS.favorites">
        <ng-container *ngIf="hasFavorites(); else noFavorites">
            <!-- Favorite Stops -->
            <div
                #favoriteStopElement="ridangoScrollIntoView"
                *ngFor="let stop of favoriteStopsShown; let i = index; last as isLast"
                [ngClass]="{
                    'py-2': !isLast,
                    'pt-2': isLast
                }"
                [attr.data-stop-id]="stop.id"
                ridangoScrollIntoView>
                <div class="my-2" *ngIf="i === 0"></div>
                <div class="shadow-md">
                    <rwidget-bus-stop-short
                        [stop]="stop"
                        [departures]="stopIdToDepartures.get(stop.id)"
                        [isLoadingDepartures]="departuresLoadingMap[stop.id]"
                        (showAllClicked)="openStopView(stop.id)"
                        (tripClick)="openTripDetailsView($event)"></rwidget-bus-stop-short>
                </div>
            </div>

            <!-- Favorite Locations -->
            <div class="mt-4 bg-white px-4 shadow-md" *ngIf="favoriteLocations?.length">
                <h2 class="py-4 text-xs font-bold uppercase leading-5 text-grey-dark dark:text-contrast-yellow">
                    {{ 'FAVORITE_LOCATIONS' | translate }}
                </h2>
                <mat-divider></mat-divider>
                <ng-container *ngFor="let location of favoriteLocations$ | async; index as i">
                    <div
                        class="orb-app-light:text-grey-zambezy flex-align-center flex cursor-pointer gap-3.5 py-3.5 dark:filter-yellow"
                        (click)="openLocation(location)">
                        <ion-icon
                            class="h-8 w-8"
                            [src]="
                                (assetsPath$ | async) +
                                (location.pointOfInterest ? '/img/explore/poi.svg' : imageMapLocationPath)
                            "></ion-icon>
                        <p class="min-w-0 flex-1 break-words leading-5">{{ location.name }}</p>
                    </div>
                    <mat-divider *ngIf="i !== favoriteLocations?.length - 1"></mat-divider>
                </ng-container>
            </div>

            <!-- Favorite Schedules -->
            <rwidget-explore-favorite-schedule></rwidget-explore-favorite-schedule>
        </ng-container>

        <!-- Action Buttons -->
        <div class="flex-column flex pb-4" *ngIf="hasFavorites() && deviceStatus">
            <ion-button
                class="var-app-light:text-primary var-app-light:normal-case m-0 cursor-pointer py-5 text-center text-base font-semibold text-secondary dark:text-contrast-yellow"
                *ngIf="showNumberOfFavorites < favoriteStopsSaved?.length"
                [class.normal-case]="env.REMOVE_UPPERCASE"
                [attr.aria-label]="'SHOW_MORE_FAVORITES' | translate"
                (click)="loadMoreFavorites()"
                fill="clear"
                >{{ 'SHOW_MORE_FAVORITES' | translate }}
            </ion-button>
            <ion-button
                class="var-app-light:text-primary var-app-light:normal-case orb-app-light-dark:capitalize var-app-light-dark:pb-8 mb-4 mt-4 cursor-pointer text-center text-base font-semibold text-secondary dark:filter-yellow"
                [class.normal-case]="env.REMOVE_UPPERCASE"
                [attr.aria-label]="'EDIT_FAVORITES' | translate"
                (click)="handleEditFavorites()"
                fill="clear">
                <ion-icon
                    class="var-app-light:text-primary mr-1 text-secondary dark:text-contrast-yellow"
                    src="{{ assetsPath$ | async }}/img/explore/icon-edit.svg"></ion-icon>
                {{ 'EDIT_FAVORITES' | translate }}
            </ion-button>
        </div>

        <ng-template #noFavorites>
            <div class="m-2 cursor-pointer px-2 py-5 text-center text-base font-semibold dark:text-contrast-yellow">
                {{ 'EXPLORE_FAVORITES_INSTRUCTION' | translate }}
            </div>
        </ng-template>
    </ng-container>

    <ng-container *ngIf="selectedTab === TABS.nearby">
        <div
            class="mt-4 shadow-md"
            #stopElement="ridangoScrollIntoView"
            *ngFor="let stop of getNearbyStopsPatch()"
            [attr.data-stop-id]="stop.id"
            [attr.data-id]="stop.id"
            ridangoScrollIntoView>
            <rwidget-bus-stop-short
                [stop]="stop"
                [departures]="stopIdToDepartures.get(stop.id)"
                [isLoadingDepartures]="departuresLoadingMap[stop.id]"
                (showAllClicked)="openStopView(stop.id)"
                (tripClick)="openTripDetailsView($event)"></rwidget-bus-stop-short>
        </div>
    </ng-container>

    <ng-container *ngIf="selectedTab === TABS.routes">
        <rwidget-explore-route-groups
            *ngIf="env.EXPLORE?.SHOW_ROUTE_GROUPS; else routes"
            [routesGroups]="routesGroups$ | async"></rwidget-explore-route-groups>

        <ng-template #routes>
            <rwidget-explore-routes class="mt-4" [routes]="routes$ | async"></rwidget-explore-routes>
        </ng-template>
    </ng-container>

    <ng-container *ngIf="selectedTab !== TABS.favorites && selectedTab !== TABS.routes">
        <ion-button
            class="var-app-light:text-primary var-app-light:normal-case var-app-light:bg-transparent var-app-light-dark:mb-8 orb-app-light-dark:mb-8 orb-app-light-dark:normal-case orb-app-light:bg-transparent m-0 mb-4 cursor-pointer bg-white py-5 text-center text-base font-semibold text-secondary dark:text-contrast-yellow"
            *ngIf="showLoadMoreStops()"
            [class.normal-case]="env.REMOVE_UPPERCASE"
            [attr.aria-label]="'SHOW_MORE_STOPS_ELLIPSIS' | translate"
            (click)="loadMoreStops()"
            fill="clear">
            <ion-icon
                class="mr-1 text-secondary dark:filter-yellow"
                *ngIf="env.EXPLORE?.SHOW_ICON_FOR_NEARBY_MORE_STOPS"
                src="{{ assetsPath$ | async }}/img/explore/icon-arrow-down-circle.svg"></ion-icon>
            {{ 'SHOW_MORE_STOPS_ELLIPSIS' | translate }}
        </ion-button>
    </ng-container>

    <div
        class="var-app-light:text-primary cursor-pointer px-2 py-5 text-center text-base font-semibold text-secondary dark:text-contrast-yellow"
        *ngIf="
            this.nearbyStops?.length === 0 &&
            !isSearchingNearbyStops &&
            !hasLocationError &&
            selectedTab === TABS.nearby
        ">
        {{ isBoundLocation | translate }}
    </div>
    <ridango-ui-basic-loading-spinner
        *ngIf="
            isSearchingNearbyStops && !hasLocationError && selectedTab !== TABS.routes
        "></ridango-ui-basic-loading-spinner>
</div>
